import React, { useState } from "react";
import {DefaultButton, Dialog, DialogFooter, PrimaryButton, TooltipHost} from '@fluentui/react';
import DeletePowerAppSolutionDialogContent from "./DeletePowerAppSolutionDialogContent";
import { renderDate } from "../../../helpers/HelperMethods";

const DeletePowerAppSolutionBtn = ({solution, updateSolution, onSaveCallback}) => {

    const [showDialog, setShowDialog] = useState(false)

    const _onConfirmDialog = () => {
        updateSolution(null, null, null, true);
        setShowDialog(false)
    }

    const _onCancelDialog = () => {
        setShowDialog(false)
    }

    const confirmationDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Confirm "${solution.name}" deletion?`,
            }}
            modalProps={{
                isBlocking: false
            }}
        >
            <div>
                {   
                    solution.lastLaunched && 
                    <div>This solution was last used on {renderDate(solution.lastLaunched)}.</div>
                }
                <div>Please ensure that deleting it will not affect other solutions.</div>
                <br />
                <div>
                    Note:
                    {
                        <div>
                            {
                                solution.groupedSolutions.length > 1 &&
                                <div>
                                    This solution is included in different environments. Please carefully review the details below before proceeding with the deletion.<br />
                                </div>
                            }
                            <div>
                                {solution.groupedSolutions.map((s, index) => <DeletePowerAppSolutionDialogContent solution={s} key={index} />)}
                            </div>
                            (Data sources are not included in this list; however, they will be deleted if any are included)<br />
                            {
                                solution.groupedSolutions.length > 1 && !solution.groupedSolutions.some(s => !s.isManagedSolution) &&
                                <div>
                                    This solution will be deleted from multiple environments. <br />
                                    Because it is a managed solution, the deletion will be permanent, and it will not be possible to restore it from any environment.
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <DialogFooter>
                <PrimaryButton onClick={_onConfirmDialog} text="Yes, delete" />
                <DefaultButton onClick={_onCancelDialog} text="No, cancel" />
            </DialogFooter>
        </Dialog>

    const icofrBlockMsg = 
        <div>
            <div><b>Deletion not allowed</b></div>
            <div>You cannot delete this element because it is within an ICOR environment, which follows a different deletion procedure.</div>
            <div>Please refer to the <a href="https://abb.sharepoint.com/:w:/t/ICoFRonPowerPlatform/EUYIXjvjlWtNnSamf4EfFXQBQWR-SM-UKt9uk3VFhTRDdA?e=ZLWYgV">ICOR guidelines</a> or contact the environment owner for further steps.</div>
        </div>

    const crossSolutionsBlockMsg = (objects) =>
        <div>
            <div><b>Deletion not allowed</b></div>
            <div>You cannot delete this solution because it contains <b>at least one element that is currently used in another solution(s).</b></div>
            <div>Affected elements:<ul>{objects.map(x => <li>{x.name}</li>)}</ul></div>
            <div>Please remove this element from any solutions where it is no longer needed.  After 24 hours from the element´s deletion, you will be able to delete this solution.</div>
        </div>

    const crossSolutionObjects = solution.groupedSolutions.flatMap(s => s.apps.filter(x => x.isCrossSolutionObject))

    const isBlocked = solution.environment.isIcofr || crossSolutionObjects.length

    const isBlockedMsg = isBlocked
        ? (
            solution.environment.isIcofr
            ? icofrBlockMsg
            : (
                crossSolutionObjects.length
                ? crossSolutionsBlockMsg(crossSolutionObjects)
                : ''
            )
        )
        : ''

    return (
        <div style={{float: 'right', marginRight: '-12px', marginLeft: '26px'}}>
            <TooltipHost content={isBlockedMsg}>
                <DefaultButton
                    text='Delete'
                    className="edit-icon"
                    onClick={() => setShowDialog(true)}
                    disabled={isBlocked}
                />
            </TooltipHost>
            {confirmationDialog}
        </div>
    )
}
    
export default DeletePowerAppSolutionBtn;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppSolutionBtn.js